export default "/assets/images/mila-valentine-black-white.webp?8d1249264f327fa6cda7825eb149a544";